// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { PatternFormat } from "react-number-format";
import { useStores } from "hooks/useStores";
import { useNavigate } from 'react-router';
import { ROUTES_PATHS } from 'const';
import { setCookie } from "utils/Cookie";
import { TOKEN_KEYS } from "const/settings";
import {CloseButtonModal} from "../CloseButton";

const Background = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(34, 34, 34, 0.5);
  z-index: 1010;
`;

const Container = styled.div`
  width: 588px;
  background-color: #ffffff;
  position: relative;
  padding: 90px 92px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 600px) {
    width: 100vw;
  }
`;

const Title = styled.h1`
  font-family: Noah;
  font-style: normal;
  font-weight: 500;
  font-size: 46px;
  line-height: 56px;
  margin: 0;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 30px;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
`;

const SubTitle = styled.h2`
  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  margin-top: 20px;
  text-align: center;
`;

const CloseBtn = styled.a`
  position: absolute;
  background: url(../../assets/icons/form-close.svg);
  width: 24px;
  height: 24px;
  right: 32px;
  top: 32px;
  cursor: pointer;
`;

const Label = styled.label`
  margin-bottom: 4px;

  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  margin-top: 40px;
`;

const inputStyle = {
  width: "200px",
  textAlign: "center",
  height: "46px",
  background: "#ffffff",
  border: "2px solid #dddde3",
  borderRadius: "6px",

  fontFamily: "Gilroy",
  fontStyle: "normal",
  fontWeight: "bold",
  fontSize: "32px",
  lineHeight: "160%",
  padding: "0 12px",
};

const Button = styled.button`
  width: 200px;
  height: 55px;
  background: #ffd600;
  border: none;
  border-radius: 6px;

  font-family: Gilroy;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 160%;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 40px;

  cursor: pointer;

  &:hover {
    background: #fbca1f;
  }
  &:disabled {
    background: #fff0b9;
  }
`;

const ContainerMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ContainerSucces = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
`;

export default function ConfirmationPopUp(email) {
  const [value, setValue] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [response, setResponse] = useState({});
  const [isCodeEntered, setIsCodeEntered] = useState(false);
  const navigate = useNavigate()

  const { api } = useStores();

  useEffect(() => {
    if (value.split("").length === 6) {
      setDisabled(false);
    }
  }, [value]);

  const confirmEmail = () => {
    api.user.postConfirm({
      email: email.email, confirm_code: value
    })
      .then((response) => setResponse(response))
  };

  const mounted = useRef(true);
  useEffect(() => {
    if (mounted.current) {
      // do componentDidMount logic
      mounted.current = false;
    } else {
      // do componentDidUpdate logic
      if (response.code_valid === true) {
        document.querySelector("#containerMain").style.display = "none";
        document.querySelector("#closeBtn-confirmPage").style.display = "none";
        document.querySelector("#containerSucces").style.display = "flex";
        localStorage.setItem("tokenData", response.token);
        setCookie(TOKEN_KEYS.AUTH_TOKEN_KEY, response.token)
      } else if (response.code_valid === false) {
        setIsCodeEntered(true);
        setValue("");
      }
    }
  }, [response]);

  const goToLk = () => {
    navigate(ROUTES_PATHS.PERSONAL)
  };

  const closeChangeEmail = () => {
    document.querySelector("#confirmationPopUp").style.display = "none";
    setValue("");
  };

  return (
    <Background id='confirmationPopUp'>
      <Container>
        <CloseButtonModal handleClose={closeChangeEmail}/>
        <ContainerMain id='containerMain'>
          {isCodeEntered ? (
            <SubTitle>Неверно введен код, попробуйте еще раз</SubTitle>
          ) : (
            <Title>Подтвердите почту</Title>
          )}
          <Label htmlFor='emailConfirm'>Введите код подтверждения</Label>
          <PatternFormat
            autoFocus
            style={inputStyle}
            value={value}
            // decimalScale='2'
            format='##-##-##'
            onValueChange={(v) => setValue(v.value)}
            // isNumericString
            placeholder='__-__-__'
          />
          <Button disabled={disabled} onClick={confirmEmail}>
            Отправить код
          </Button>
        </ContainerMain>
        <ContainerSucces id='containerSucces'>
          <Title>Почта успешно подтверждена!</Title>
          <Button onClick={goToLk}>Перейти в личный кабинет</Button>
        </ContainerSucces>
      </Container>
    </Background>
  );
}
